import React, { useEffect, useState } from 'react';
import { UserCardV1 } from '../../../../features/User/UserCard';
import { useTemplate } from '../../../../features/template/TemplateProvider';
import { GetDate, GetTime } from '../../../../utils/Show';
import cn from '../../../../utils/cn';
import { ApiGetServiceActivityLog } from '../ServicesManageOperation';

const initialState = {
    activityLog: []
};

// function Member({ item }) {
//     const navigate = useNavigate();
//     return (
//         <button
//             type="button"
//             className="flex gap-2 bg-primary-100 px-1.5 py-0.5 rounded-5"
//             onClick={() => navigate(mkRelativeUrl(`/settings/admins/${item?.id}/info`))}
//         >
//             <span> {item.fullName}</span>
//         </button>
//     );
// }

function TableHeader() {
    return (
        <thead>
            <tr className="text-primary cursor-default">
                <th scope="col" className="w-20">
                    <span>ID</span>
                </th>
                <th scope="col">
                    <span>Activity By</span>
                </th>
                <th scope="col">
                    <span>Members</span>
                </th>
                <th>
                    <span>Title</span>
                </th>
                <th>
                    <span>Description</span>
                </th>
                <th scope="col" className="!w-38 !text-center">
                    <span>Date Created</span>
                </th>
            </tr>
        </thead>
    );
}
function TableRow({ item }) {
    const displayMembers = item.members.map((i, index) => {
        if (index === item.members.length - 1) {
            // Last i, no comma needed
            return i?.fullName;
        }
        // Not the last i, add a comma
        return `${i?.fullName}, `;
    });

    return (
        <tr
            className={cn('hover:!bg-secondary-50', {
                'placeholder-mode': item?.demo
            })}
        >
            <td>
                <span>{item?.id}</span>
            </td>
            <td>
                <span>
                    <UserCardV1
                        hide
                        title={item?.userInfo?.fullName}
                        subTitle={item?.userInfo?.primaryEmail}
                        className="[&>div>h1]:!text-sm [&>div>p]:!text-xs"
                    />
                </span>
            </td>
            <td>
                <span className="font-medium">
                    {item?.members?.length ? displayMembers : '---'}
                </span>
            </td>
            <td>
                <span>{item?.title}</span>
            </td>
            <td>
                <span>{item?.description}</span>
            </td>
            <td className="!text-center">
                <span>
                    {GetDate(item?.timeCreated)}
                    <br />
                    <small>{GetTime(item?.timeCreated)}</small>
                </span>
            </td>
        </tr>
    );
}
function ViewServiceActivityLogModal({ data }) {
    const { setMessage } = useTemplate();
    const [info, setInfo] = useState(initialState);
    const [loading, setLoading] = useState(false);
    console.log(loading);
    useEffect(() => {
        setLoading(true);
        ApiGetServiceActivityLog(data.id)
            .then(({ data: resData }) => {
                setLoading(false);
                setInfo({
                    activityLog: resData?.activityLog
                });
            })
            .catch((err) => {
                setLoading(false);
                setInfo(initialState);
                setMessage({ type: 'error', text: err.toString(0) });
            });
    }, [data, setMessage]);
    return (
        <div className="w-full min-h-60">
            <table className="bik-table mb-4">
                <TableHeader />
                <tbody>
                    {info && info?.activityLog?.length === 0 ? (
                        <tr className="hover:!bg-inherit">
                            <td colSpan={5} className="!text-left">
                                No Activity Found!
                            </td>
                        </tr>
                    ) : (
                        info?.activityLog?.map((item) => <TableRow key={item?.id} item={item} />)
                    )}
                </tbody>
            </table>

            {/* {info && info?.members?.length ? (
                <div>
                    <h2 className="text-lg font-medium mb-1">Members:</h2>
                    <div className="flex gap-1">
                        {info?.members?.map((item) => (
                            <Member key={item.id} item={item} />
                        ))}
                    </div>
                </div>
            ) : null} */}
        </div>
    );
}

export default ViewServiceActivityLogModal;
